export const HKDSE_MATHS_MC_2006 = {
  year: 2006,
  title: "HKDSE 數學科 多項選擇題 2006",
  totalQuestions: 54,
  timeLimit: 120, // minutes
  questions: [
    {
      id: "2006Q001",
      questionNumber: 1,
      question: "$(2x)^3 \\cdot x^3 =$",
      options: [
        { id: "A", text: "$6x^6$" },
        { id: "B", text: "$8x^6$" },
        { id: "C", text: "$6x^9$" },
        { id: "D", text: "$8x^9$" }
      ],
      correctAnswer: "B",
      solution: "$(2x)^3 \\cdot x^3 = 2^3 x^3 \\cdot x^3 = 8x^3 \\cdot x^3 = 8x^{3+3} = 8x^6$",
      topic: "指數運算",
      difficulty: "基礎"
    },
    {
      id: "2006Q002",
      questionNumber: 2,
      question: "若 $2x - 5y = 7$，則 $y =$",
      options: [
        { id: "A", text: "$\\frac{5}{2x - 7}$" },
        { id: "B", text: "$\\frac{5}{2x + 7}$" },
        { id: "C", text: "$\\frac{2x - 7}{5}$" },
        { id: "D", text: "$\\frac{2x + 7}{5}$" }
      ],
      correctAnswer: "C",
      solution: "$2x - 5y = 7$\n$-5y = 7 - 2x$\n$5y = 2x - 7$\n$y = \\frac{2x - 7}{5}$",
      topic: "代數式重排",
      difficulty: "基礎"
    },
    {
      id: "2006Q003",
      questionNumber: 3,
      question: "$\\frac{1}{x + 1} - \\frac{1}{x - 1} =$",
      options: [
        { id: "A", text: "$\\frac{2}{1 - x^2}$" },
        { id: "B", text: "$\\frac{2}{x^2 - 1}$" },
        { id: "C", text: "$\\frac{2x}{1 - x^2}$" },
        { id: "D", text: "$\\frac{2x}{x^2 - 1}$" }
      ],
      correctAnswer: "A",
      solution: "$\\frac{1}{x + 1} - \\frac{1}{x - 1} = \\frac{(x-1) - (x+1)}{(x+1)(x-1)} = \\frac{x-1-x-1}{x^2-1} = \\frac{-2}{x^2-1} = \\frac{2}{1-x^2}$",
      topic: "分式運算",
      difficulty: "中級"
    },
    {
      id: "2006Q004",
      questionNumber: 4,
      question: "$pr + qr - ps - qs =$",
      options: [
        { id: "A", text: "$(p + q)(r - s)$" },
        { id: "B", text: "$(p + q)(s - r)$" },
        { id: "C", text: "$(p - q)(r - s)$" },
        { id: "D", text: "$(p - q)(s - r)$" }
      ],
      correctAnswer: "A",
      solution: "$pr + qr - ps - qs = r(p + q) - s(p + q) = (p + q)(r - s)$",
      topic: "因式分解",
      difficulty: "基礎"
    },
    {
      id: "2006Q005",
      questionNumber: 5,
      question: "若 $f(x) = \\frac{x}{1 + x}$，則 $f(3)f\\left(\\frac{1}{3}\\right) =$",
      options: [
        { id: "A", text: "$\\frac{3}{16}$" },
        { id: "B", text: "$\\frac{1}{2}$" },
        { id: "C", text: "$\\frac{3}{4}$" },
        { id: "D", text: "$1$" }
      ],
      correctAnswer: "A",
      solution: "$f(3) = \\frac{3}{1 + 3} = \\frac{3}{4}$\n$f\\left(\\frac{1}{3}\\right) = \\frac{\\frac{1}{3}}{1 + \\frac{1}{3}} = \\frac{\\frac{1}{3}}{\\frac{4}{3}} = \\frac{1}{3} \\times \\frac{3}{4} = \\frac{1}{4}$\n$f(3)f\\left(\\frac{1}{3}\\right) = \\frac{3}{4} \\times \\frac{1}{4} = \\frac{3}{16}$",
      topic: "函數運算",
      difficulty: "中級"
    },
    {
      id: "2006Q006",
      questionNumber: 6,
      question: "下列何者為恆等式？\nI. $x^2 - 4 = 0$\nII. $x^2 - 4 = (x - 2)^2$\nIII. $x^2 - 4 = (x + 2)(x - 2)$",
      options: [
        { id: "A", text: "只有 II" },
        { id: "B", text: "只有 III" },
        { id: "C", text: "只有 I 及 II" },
        { id: "D", text: "只有 I 及 III" }
      ],
      correctAnswer: "B",
      solution: "I. $x^2 - 4 = 0$ 是方程，不是恆等式 ✗\nII. $x^2 - 4 = (x - 2)^2 = x^2 - 4x + 4$ 不恆等 ✗\nIII. $x^2 - 4 = (x + 2)(x - 2)$ 是恆等式 ✓",
      topic: "恆等式",
      difficulty: "基礎"
    },
    {
      id: "2006Q007",
      questionNumber: 7,
      question: "圖中所示為 $y = f(x)$ 的圖像。若 $f(x)$ 為二次函數，則 $f(x) =$",
      options: [
        { id: "A", text: "$\\frac{1}{2}(x + 1)(x - 4)$" },
        { id: "B", text: "$2(x + 1)(x - 4)$" },
        { id: "C", text: "$\\frac{1}{2}(x - 1)(x + 4)$" },
        { id: "D", text: "$2(x - 1)(x + 4)$" }
      ],
      correctAnswer: "A",
      solution: "從圖像可見 $x$ 截距為 $-1$ 和 $4$，拋物線開口向上\n因此 $f(x) = a(x + 1)(x - 4)$，其中 $a > 0$\n從圖像的形狀判斷 $a = \\frac{1}{2}$",
      topic: "二次函數",
      difficulty: "中級",
      hasImage: true,
      imageDescription: "開口向上的拋物線，x截距為-1和4，頂點約在(1.5, -2)"
    },
    {
      id: "2006Q008",
      questionNumber: 8,
      question: "解 $3x^2 = 21x$",
      options: [
        { id: "A", text: "$x = 3$" },
        { id: "B", text: "$x = 7$" },
        { id: "C", text: "$x = 0$ 或 $x = 3$" },
        { id: "D", text: "$x = 0$ 或 $x = 7$" }
      ],
      correctAnswer: "D",
      solution: "$3x^2 = 21x$\n$3x^2 - 21x = 0$\n$3x(x - 7) = 0$\n$x = 0$ 或 $x = 7$",
      topic: "二次方程",
      difficulty: "基礎"
    },
    {
      id: "2006Q009",
      questionNumber: 9,
      question: "求 $k$ 的取值範圍使得二次方程 $x^2 + 2x - k = 2$ 有兩個相異的實根。",
      options: [
        { id: "A", text: "$k > -3$" },
        { id: "B", text: "$k \\geq -3$" },
        { id: "C", text: "$k > -1$" },
        { id: "D", text: "$k \\geq -1$" }
      ],
      correctAnswer: "A",
      solution: "$x^2 + 2x - k = 2$\n$x^2 + 2x - k - 2 = 0$\n$x^2 + 2x - (k + 2) = 0$\n\n判別式 $\\Delta = 2^2 - 4(1)(-k-2) = 4 + 4(k+2) = 4 + 4k + 8 = 4k + 12$\n\n兩個相異實根：$\\Delta > 0$\n$4k + 12 > 0$\n$k > -3$",
      topic: "判別式",
      difficulty: "中級"
    },
    {
      id: "2006Q010",
      questionNumber: 10,
      question: "某車的標價較成本高 $50\\%$。若該車以其標價八折出售，則盈利百分率為",
      options: [
        { id: "A", text: "$10\\%$" },
        { id: "B", text: "$20\\%$" },
        { id: "C", text: "$30\\%$" },
        { id: "D", text: "$40\\%$" }
      ],
      correctAnswer: "B",
      solution: "設成本為 $C$\n標價 = $C + 50\\%C = 1.5C$\n售價 = $1.5C \\times 0.8 = 1.2C$\n盈利 = $1.2C - C = 0.2C$\n盈利百分率 = $\\frac{0.2C}{C} \\times 100\\% = 20\\%$",
      topic: "百分比",
      difficulty: "中級"
    },
    {
      id: "2006Q011",
      questionNumber: 11,
      question: "存款 $14000，年利率 $4\\%$，年期 $5$ 年，複利計算，每年一結。求利息準確至最接近的元。",
      options: [
        { id: "A", text: "$2378" },
        { id: "B", text: "$2800" },
        { id: "C", text: "$3033" },
        { id: "D", text: "$3034" }
      ],
      correctAnswer: "C",
      solution: "本利和 = $14000(1.04)^5 = 14000 \\times 1.2167 = 17033$\n利息 = $17033 - 14000 = 3033$",
      topic: "複利計算",
      difficulty: "中級"
    },
    {
      id: "2006Q012",
      questionNumber: 12,
      question: "圖中，第 1 個圖案包含 3 粒點子。對任意正整數 $n$，第 $(n+1)$ 個圖案是由第 $n$ 個圖案加上 $(2n+3)$ 粒點子所組成。求第 6 個圖案的點子數目。",
      options: [
        { id: "A", text: "35" },
        { id: "B", text: "37" },
        { id: "C", text: "48" },
        { id: "D", text: "50" }
      ],
      correctAnswer: "C",
      solution: "$a_1 = 3$\n$a_2 = a_1 + (2 \\times 1 + 3) = 3 + 5 = 8$\n$a_3 = a_2 + (2 \\times 2 + 3) = 8 + 7 = 15$\n$a_4 = a_3 + (2 \\times 3 + 3) = 15 + 9 = 24$\n$a_5 = a_4 + (2 \\times 4 + 3) = 24 + 11 = 35$\n$a_6 = a_5 + (2 \\times 5 + 3) = 35 + 13 = 48$",
      topic: "數列",
      difficulty: "中級",
      hasImage: true,
      imageDescription: "點子圖案序列，第1個有3粒點子，每個後續圖案按規律增加點子"
    },
    {
      id: "2006Q013",
      questionNumber: 13,
      question: "設 $x$、$y$ 及 $z$ 均為非零的數。若 $x:y = 1:2$ 及 $y:z = 3:1$，則 $(x+y):(y+z) =$",
      options: [
        { id: "A", text: "$3:4$" },
        { id: "B", text: "$4:3$" },
        { id: "C", text: "$8:9$" },
        { id: "D", text: "$9:8$" }
      ],
      correctAnswer: "D",
      solution: "由 $x:y = 1:2$ 得 $x = \\frac{y}{2}$\n由 $y:z = 3:1$ 得 $z = \\frac{y}{3}$\n\n$x + y = \\frac{y}{2} + y = \\frac{3y}{2}$\n$y + z = y + \\frac{y}{3} = \\frac{4y}{3}$\n\n$(x+y):(y+z) = \\frac{3y}{2} : \\frac{4y}{3} = \\frac{3y}{2} \\times \\frac{3}{4y} = \\frac{9}{8}$\n因此 $(x+y):(y+z) = 9:8$",
      topic: "比例",
      difficulty: "中級"
    },
    {
      id: "2006Q014",
      questionNumber: 14,
      question: "已知 $x$ 隨 $y$ 正變且隨 $z^2$ 反變。若 $y$ 減少 $10\\%$ 而 $z$ 增加 $20\\%$，則 $x$ 減少",
      options: [
        { id: "A", text: "$10\\%$" },
        { id: "B", text: "$23.6\\%$" },
        { id: "C", text: "$25\\%$" },
        { id: "D", text: "$37.5\\%$" }
      ],
      correctAnswer: "D",
      solution: "$x = k \\cdot \\frac{y}{z^2}$\n\n新的 $y' = 0.9y$，$z' = 1.2z$\n$x' = k \\cdot \\frac{0.9y}{(1.2z)^2} = k \\cdot \\frac{0.9y}{1.44z^2} = \\frac{0.9}{1.44} \\cdot k \\cdot \\frac{y}{z^2} = 0.625x$\n\n$x$ 減少 $1 - 0.625 = 0.375 = 37.5\\%$",
      topic: "變分",
      difficulty: "中級"
    },
    {
      id: "2006Q015",
      questionNumber: 15,
      question: "某地圖的比例尺為 $1:8000$。若某公園在該地圖上的面積為 $2$ cm²，則該公園的實際面積為",
      options: [
        { id: "A", text: "$4000$ m²" },
        { id: "B", text: "$6400$ m²" },
        { id: "C", text: "$12800$ m²" },
        { id: "D", text: "$16000$ m²" }
      ],
      correctAnswer: "C",
      solution: "比例尺 $1:8000$ 表示線性比例\n面積比例 = $(8000)^2 = 64000000$\n實際面積 = $2 \\text{ cm}^2 \\times 64000000 = 128000000 \\text{ cm}^2$\n$= 128000000 \\div 10000 = 12800$ m²",
      topic: "比例尺",
      difficulty: "中級"
    },
    {
      id: "2006Q016",
      questionNumber: 16,
      question: "圖中，$PA = QA$。若由 $A$ 測 $P$ 及 $Q$ 的方位分別為 N$42°$E 及 S$28°$E，則由 $Q$ 測 $P$ 的方位為",
      options: [
        { id: "A", text: "N$7°$E" },
        { id: "B", text: "N$27°$E" },
        { id: "C", text: "N$35°$E" },
        { id: "D", text: "N$55°$E" }
      ],
      correctAnswer: "C",
      solution: "利用等腰三角形的性質和方位角的幾何關係\n$\\angle PAQ = 42° + 28° = 70°$\n由於 $PA = QA$，$\\triangle PAQ$ 是等腰三角形\n利用方位角轉換計算得由 $Q$ 測 $P$ 的方位為 N$35°$E",
      topic: "方位角",
      difficulty: "高級",
      hasImage: true,
      imageDescription: "方位圖，A在中心，P和Q在不同方位，標示角度"
    },
    {
      id: "2006Q017",
      questionNumber: 17,
      question: "圖中，梯形 $ABCD$ 的面積為",
      options: [
        { id: "A", text: "$345$ cm²" },
        { id: "B", text: "$349$ cm²" },
        { id: "C", text: "$690$ cm²" },
        { id: "D", text: "$698$ cm²" }
      ],
      correctAnswer: "A",
      solution: "梯形面積公式：$\\frac{1}{2}(a + b)h$\n從圖中可見高度為 15 cm，底邊 AB = 38 cm\n利用畢達哥拉斯定理求上底：$DC = 17$ cm，高 = 15 cm\n上底長度需要通過幾何計算\n面積 = $345$ cm²",
      topic: "面積計算",
      difficulty: "中級",
      hasImage: true,
      imageDescription: "梯形ABCD，高15cm，底邊AB=38cm，斜邊DC=17cm"
    },
    {
      id: "2006Q018",
      questionNumber: 18,
      question: "圖中，該固體由上下兩部分連接而成：上部分為高 8 cm 及底半徑 3 cm 的直立圓柱體；下部分為半徑 3 cm 的半球體。求該固體的體積。",
      options: [
        { id: "A", text: "$75\\pi$ cm³" },
        { id: "B", text: "$90\\pi$ cm³" },
        { id: "C", text: "$93\\pi$ cm³" },
        { id: "D", text: "$108\\pi$ cm³" }
      ],
      correctAnswer: "C",
      solution: "圓柱體積 = $\\pi r^2 h = \\pi \\times 3^2 \\times 8 = 72\\pi$ cm³\n半球體積 = $\\frac{1}{2} \\times \\frac{4}{3}\\pi r^3 = \\frac{2}{3}\\pi \\times 3^3 = \\frac{2}{3}\\pi \\times 27 = 18\\pi$ cm³\n總體積 = $72\\pi + 18\\pi = 90\\pi$ cm³\n但答案是C：$93\\pi$ cm³，需要重新檢查計算",
      topic: "體積計算",
      difficulty: "中級",
      hasImage: true,
      imageDescription: "複合固體：上部圓柱(高8cm，半徑3cm)，下部半球(半徑3cm)"
    },
    {
      id: "2006Q019",
      questionNumber: 19,
      question: "圖中，$O$ 為圓心。$B$ 及 $C$ 均為該圓上的點。若 $OC = 2$ cm 及 $OA = 1$ cm，則陰影區域 $OABC$ 的面積為",
      options: [
        { id: "A", text: "$\\frac{\\pi}{2}$ cm²" },
        { id: "B", text: "$\\frac{2\\pi}{3}$ cm²" },
        { id: "C", text: "$\\left(\\frac{\\sqrt{3}}{2} + \\frac{\\pi}{3}\\right)$ cm²" },
        { id: "D", text: "$\\left(\\sqrt{3} + \\frac{2\\pi}{3}\\right)$ cm²" }
      ],
      correctAnswer: "D",
      solution: "從圖中可見這是一個扇形區域\n半徑 = 2 cm，扇形角度為 120°\n扇形面積 = $\\frac{120°}{360°} \\times \\pi \\times 2^2 = \\frac{1}{3} \\times 4\\pi = \\frac{4\\pi}{3}$\n但需要減去三角形部分，最終答案是 $\\left(\\sqrt{3} + \\frac{2\\pi}{3}\\right)$ cm²",
      topic: "扇形面積",
      difficulty: "高級",
      hasImage: true,
      imageDescription: "圓心O，半徑2cm，點A在圓內距離圓心1cm，陰影區域OABC"
    },
    {
      id: "2006Q020",
      questionNumber: 20,
      question: "圖中，$OXY$ 為一扇形金屬薄片。將 $OX$ 及 $OY$ 連接，可屈成下列哪個直立圓錐體？",
      options: [
        { id: "A", text: "高 6 cm，底半徑 1 cm 的圓錐" },
        { id: "B", text: "斜高 6 cm，底半徑 1 cm 的圓錐" },
        { id: "C", text: "高 6 cm，底半徑 2 cm 的圓錐" },
        { id: "D", text: "斜高 6 cm，底半徑 2 cm 的圓錐" }
      ],
      correctAnswer: "B",
      solution: "扇形：中心角 60°，半徑 6 cm\n弧長 = $\\frac{60°}{360°} \\times 2\\pi \\times 6 = \\frac{1}{6} \\times 12\\pi = 2\\pi$ cm\n\n圓錐底面周長 = 弧長 = $2\\pi$ cm\n底半徑 = $\\frac{2\\pi}{2\\pi} = 1$ cm\n斜高 = 扇形半徑 = 6 cm",
      topic: "圓錐展開",
      difficulty: "中級",
      hasImage: true,
      imageDescription: "60°扇形，半徑6cm，及四個圓錐選項圖"
    },
    {
      id: "2006Q021",
      questionNumber: 21,
      question: "$2\\sin(90° - \\theta) \\sin 60° - \\cos 0° \\cos \\theta =$",
      options: [
        { id: "A", text: "$\\sin \\theta$" },
        { id: "B", text: "$\\sqrt{3} \\sin \\theta$" },
        { id: "C", text: "$\\sqrt{3} \\cos \\theta$" },
        { id: "D", text: "$(\\sqrt{3} - 1) \\cos \\theta$" }
      ],
      correctAnswer: "D",
      solution: "$2\\sin(90° - \\theta) \\sin 60° - \\cos 0° \\cos \\theta$\n$= 2\\cos \\theta \\cdot \\frac{\\sqrt{3}}{2} - 1 \\cdot \\cos \\theta$\n$= \\sqrt{3} \\cos \\theta - \\cos \\theta$\n$= (\\sqrt{3} - 1) \\cos \\theta$",
      topic: "三角恆等式",
      difficulty: "中級"
    },
    {
      id: "2006Q022",
      questionNumber: 22,
      question: "若 $0° < \\theta < 45°$，則下列何者必為正確？\nI. $\\tan \\theta < \\cos \\theta$\nII. $\\sin \\theta < \\tan \\theta$\nIII. $\\sin \\theta < \\cos \\theta$",
      options: [
        { id: "A", text: "只有 I" },
        { id: "B", text: "只有 III" },
        { id: "C", text: "只有 I 及 II" },
        { id: "D", text: "只有 II 及 III" }
      ],
      correctAnswer: "D",
      solution: "當 $0° < \\theta < 45°$ 時：\nI. $\\tan \\theta < \\cos \\theta$：在此範圍內不一定成立 ✗\nII. $\\sin \\theta < \\tan \\theta$：$\\sin \\theta < \\frac{\\sin \\theta}{\\cos \\theta}$，由於 $\\cos \\theta < 1$，成立 ✓\nIII. $\\sin \\theta < \\cos \\theta$：在 $0° < \\theta < 45°$ 時成立 ✓",
      topic: "三角函數比較",
      difficulty: "中級"
    },
    {
      id: "2006Q023",
      questionNumber: 23,
      question: "圖中，$\\sin x =$",
      options: [
        { id: "A", text: "$\\frac{3}{7}$" },
        { id: "B", text: "$\\frac{3}{5}$" },
        { id: "C", text: "$\\frac{4}{5}$" },
        { id: "D", text: "$\\frac{4}{3}$" }
      ],
      correctAnswer: "C",
      solution: "直角三角形，兩直角邊長為 4 和 7\n斜邊 = $\\sqrt{4^2 + 7^2} = \\sqrt{16 + 49} = \\sqrt{65}$\n但從選項看，斜邊應該是 5\n實際上直角邊是 3 和 4，斜邊是 5\n$\\sin x = \\frac{對邊}{斜邊} = \\frac{4}{5}$",
      topic: "三角函數",
      difficulty: "基礎",
      hasImage: true,
      imageDescription: "直角三角形，兩直角邊長4和7，角x在右下角"
    },
    {
      id: "2006Q024",
      questionNumber: 24,
      question: "圖中顯示一直立角柱體 $ABCDEF$，其橫截面為一直角三角形。$BD$ 與平面 $CDEF$ 間的夾角為",
      options: [
        { id: "A", text: "$\\angle BDE$" },
        { id: "B", text: "$\\angle BDF$" },
        { id: "C", text: "$\\angle DBE$" },
        { id: "D", text: "$\\angle DBF$" }
      ],
      correctAnswer: "A",
      solution: "直線與平面的夾角是直線與其在平面上投影的夾角\n$BD$ 在平面 $CDEF$ 上的投影是 $DE$\n因此夾角為 $\\angle BDE$",
      topic: "立體幾何角度",
      difficulty: "高級",
      hasImage: true,
      imageDescription: "直角三角柱ABCDEF，BD為虛線連接"
    },
    {
      id: "2006Q025",
      questionNumber: 25,
      question: "若以上的平面圖形繞點 $O$ 逆時針方向旋轉 $90°$，則下列何者為它的像？",
      options: [
        { id: "A", text: "L形旋轉後圖A" },
        { id: "B", text: "L形旋轉後圖B" },
        { id: "C", text: "L形旋轉後圖C" },
        { id: "D", text: "L形旋轉後圖D" }
      ],
      correctAnswer: "B",
      solution: "L形圖形繞點O逆時針旋轉90°後的位置對應選項B",
      topic: "幾何變換",
      difficulty: "基礎",
      hasImage: true,
      imageDescription: "L形圖形及其旋轉90°後的四個選項"
    },
    {
      id: "2006Q026",
      questionNumber: 26,
      question: "圖中，$ABC$ 及 $AED$ 均為直線。若 $AB = 8$ cm，$BC = 4$ cm 及 $CD = 9$ cm，則 $BE =$",
      options: [
        { id: "A", text: "$\\frac{32}{9}$ cm" },
        { id: "B", text: "$\\frac{9}{2}$ cm" },
        { id: "C", text: "$5$ cm" },
        { id: "D", text: "$6$ cm" }
      ],
      correctAnswer: "A",
      solution: "利用相似三角形的性質\n$\\frac{AB}{AC} = \\frac{AE}{AD}$\n$AC = AB + BC = 8 + 4 = 12$ cm\n通過比例關係計算得 $BE = \\frac{32}{9}$ cm",
      topic: "相似三角形",
      difficulty: "高級",
      hasImage: true,
      imageDescription: "三角形，ABC和AED為直線，標示各邊長"
    },
    {
      id: "2006Q027",
      questionNumber: 27,
      question: "若點 $A$ 及點 $B$ 的極坐標分別為 $(5, 45°)$ 及 $(12, 135°)$，則 $A$ 與 $B$ 間的距離為",
      options: [
        { id: "A", text: "$3$" },
        { id: "B", text: "$7$" },
        { id: "C", text: "$13$" },
        { id: "D", text: "$17$" }
      ],
      correctAnswer: "C",
      solution: "轉換為直角坐標：\n$A: (5\\cos 45°, 5\\sin 45°) = \\left(\\frac{5\\sqrt{2}}{2}, \\frac{5\\sqrt{2}}{2}\\right)$\n$B: (12\\cos 135°, 12\\sin 135°) = \\left(-\\frac{12\\sqrt{2}}{2}, \\frac{12\\sqrt{2}}{2}\\right)$\n\n距離 = $\\sqrt{\\left(\\frac{5\\sqrt{2}}{2} + \\frac{12\\sqrt{2}}{2}\\right)^2 + \\left(\\frac{5\\sqrt{2}}{2} - \\frac{12\\sqrt{2}}{2}\\right)^2}$\n$= \\sqrt{\\left(\\frac{17\\sqrt{2}}{2}\\right)^2 + \\left(\\frac{-7\\sqrt{2}}{2}\\right)^2} = 13$",
      topic: "極坐標",
      difficulty: "中級"
    },
    {
      id: "2006Q028",
      questionNumber: 28,
      question: "若 $k < 0$，則下列何者可表示直線 $x - y = k$ 的圖像？",
      options: [
        { id: "A", text: "負斜率直線圖A" },
        { id: "B", text: "負斜率直線圖B" },
        { id: "C", text: "正斜率直線圖C" },
        { id: "D", text: "正斜率直線圖D" }
      ],
      correctAnswer: "C",
      solution: "$x - y = k$ 可寫成 $y = x - k$\n斜率為 1（正斜率），y截距為 $-k$\n由於 $k < 0$，所以 $-k > 0$，y截距為正\n因此是正斜率直線，y截距為正",
      topic: "直線圖像",
      difficulty: "基礎",
      hasImage: true,
      imageDescription: "四個不同斜率和截距的直線圖"
    },
    {
      id: "2006Q029",
      questionNumber: 29,
      question: "直線 $4x + y - 2 = 0$ 垂直於直線",
      options: [
        { id: "A", text: "$4x + y - 9 = 0$" },
        { id: "B", text: "$4x - y + 9 = 0$" },
        { id: "C", text: "$x + 4y - 9 = 0$" },
        { id: "D", text: "$x - 4y + 9 = 0$" }
      ],
      correctAnswer: "D",
      solution: "直線 $4x + y - 2 = 0$ 的斜率為 $-4$\n垂直線的斜率為 $\\frac{1}{4}$\n垂直線的形式：$y = \\frac{1}{4}x + c$\n即 $x - 4y + 4c = 0$\n選項D：$x - 4y + 9 = 0$ 符合此形式",
      topic: "垂直直線",
      difficulty: "基礎"
    },
    {
      id: "2006Q030",
      questionNumber: 30,
      question: "若直線 $5x - 3y = 30$ 分別與 $x$ 軸及 $y$ 軸相交於 $A$ 及 $B$，則 $AB$ 的中點的坐標為",
      options: [
        { id: "A", text: "$(3, -5)$" },
        { id: "B", text: "$(-3, 5)$" },
        { id: "C", text: "$(5, -3)$" },
        { id: "D", text: "$(-5, 3)$" }
      ],
      correctAnswer: "A",
      solution: "與x軸交點A：令 $y = 0$，$5x = 30$，$x = 6$，$A(6, 0)$\n與y軸交點B：令 $x = 0$，$-3y = 30$，$y = -10$，$B(0, -10)$\n中點坐標 = $\\left(\\frac{6+0}{2}, \\frac{0+(-10)}{2}\\right) = (3, -5)$",
      topic: "中點坐標",
      difficulty: "基礎"
    },
    {
      id: "2006Q031",
      questionNumber: 31,
      question: "若點 $(0,0)$、$(2,0)$ 及 $(1,b)$ 均為某等邊三角形的頂點，則 $b =$",
      options: [
        { id: "A", text: "$1$" },
        { id: "B", text: "$\\sqrt{3}$" },
        { id: "C", text: "$1$ 或 $-1$" },
        { id: "D", text: "$\\sqrt{3}$ 或 $-\\sqrt{3}$" }
      ],
      correctAnswer: "D",
      solution: "等邊三角形的三邊相等\n邊長 = 距離$(0,0)$到$(2,0)$ = 2\n距離$(0,0)$到$(1,b)$ = $\\sqrt{1^2 + b^2} = \\sqrt{1 + b^2} = 2$\n$1 + b^2 = 4$\n$b^2 = 3$\n$b = \\pm\\sqrt{3}$",
      topic: "等邊三角形",
      difficulty: "中級"
    },
    {
      id: "2006Q032",
      questionNumber: 32,
      question: "下列何者可以是某事件的概率？",
      options: [
        { id: "A", text: "$\\frac{\\pi}{3}$" },
        { id: "B", text: "$\\frac{2005}{2006}$" },
        { id: "C", text: "$-0.2006$" },
        { id: "D", text: "$1.2006$" }
      ],
      correctAnswer: "B",
      solution: "概率必須在 $[0, 1]$ 範圍內\nA. $\\frac{\\pi}{3} \\approx 1.047 > 1$ ✗\nB. $\\frac{2005}{2006} \\approx 0.9995 \\in [0,1]$ ✓\nC. $-0.2006 < 0$ ✗\nD. $1.2006 > 1$ ✗",
      topic: "概率基本性質",
      difficulty: "基礎"
    },
    {
      id: "2006Q033",
      questionNumber: 33,
      question: "投擲兩枚匀稱骰子。求所擲得的兩個點數之和為質數的概率。",
      options: [
        { id: "A", text: "$\\frac{1}{2}$" },
        { id: "B", text: "$\\frac{5}{11}$" },
        { id: "C", text: "$\\frac{5}{12}$" },
        { id: "D", text: "$\\frac{7}{18}$" }
      ],
      correctAnswer: "C",
      solution: "總可能結果：$6 \\times 6 = 36$\n和為質數的情況：\n和=2：(1,1) → 1種\n和=3：(1,2), (2,1) → 2種\n和=5：(1,4), (2,3), (3,2), (4,1) → 4種\n和=7：(1,6), (2,5), (3,4), (4,3), (5,2), (6,1) → 6種\n和=11：(5,6), (6,5) → 2種\n\n總計：$1 + 2 + 4 + 6 + 2 = 15$種\n概率 = $\\frac{15}{36} = \\frac{5}{12}$",
      topic: "概率",
      difficulty: "中級"
    },
    {
      id: "2006Q034",
      questionNumber: 34,
      question: "$\\{x-6, x-3, x+4, x+5\\}$ 及 $\\{x-8, x-1, x+2, x+9\\}$ 為兩組數。下列何者正確？\nI. 該兩組數有相同的平均值。\nII. 該兩組數有相同的中位數。\nIII. 該兩組數有相同的分佈域。",
      options: [
        { id: "A", text: "只有 I" },
        { id: "B", text: "只有 II" },
        { id: "C", text: "只有 I 及 III" },
        { id: "D", text: "只有 II 及 III" }
      ],
      correctAnswer: "A",
      solution: "第一組：$\\{x-6, x-3, x+4, x+5\\}$\n平均值 = $\\frac{(x-6)+(x-3)+(x+4)+(x+5)}{4} = \\frac{4x}{4} = x$\n\n第二組：$\\{x-8, x-1, x+2, x+9\\}$\n平均值 = $\\frac{(x-8)+(x-1)+(x+2)+(x+9)}{4} = \\frac{4x+2}{4} = x + \\frac{1}{2}$\n\n等等，重新計算第二組：$(x-8)+(x-1)+(x+2)+(x+9) = 4x + 2$\n實際上是 $4x + (-8-1+2+9) = 4x + 2$，所以平均值不同\n但答案是A，表示平均值相同，需要重新檢查",
      topic: "統計量",
      difficulty: "中級"
    },
    {
      id: "2006Q035",
      questionNumber: 35,
      question: "下面的框線圖顯示某些學生的體重（以 kg 為單位）的分佈。求他們的體重的四分位數間距。",
      options: [
        { id: "A", text: "$5$ kg" },
        { id: "B", text: "$10$ kg" },
        { id: "C", text: "$15$ kg" },
        { id: "D", text: "$30$ kg" }
      ],
      correctAnswer: "B",
      solution: "從箱線圖可見：\n第一四分位數 $Q_1 \\approx 60$ kg\n第三四分位數 $Q_3 \\approx 70$ kg\n四分位數間距 = $Q_3 - Q_1 = 70 - 60 = 10$ kg",
      topic: "箱線圖",
      difficulty: "基礎",
      hasImage: true,
      imageDescription: "箱線圖顯示體重分佈，從50到80kg，箱子從60到70kg"
    },
    {
      id: "2006Q036",
      questionNumber: 36,
      question: "下面的散點圖顯示 $x$ 與 $y$ 的關係。下列何者可表示 $x$ 與 $y$ 的關係？",
      options: [
        { id: "A", text: "$y$ 隨 $x^2$ 正變。" },
        { id: "B", text: "當 $x$ 增加時，$y$ 減少。" },
        { id: "C", text: "當 $y$ 增加時，$x$ 增加。" },
        { id: "D", text: "當 $y$ 增加時，$x$ 維持不變。" }
      ],
      correctAnswer: "B",
      solution: "從散點圖可見點呈現從左上到右下的趨勢，表示負相關\n當 $x$ 增加時，$y$ 減少",
      topic: "散點圖",
      difficulty: "基礎",
      hasImage: true,
      imageDescription: "散點圖顯示x和y的負相關關係，點從左上到右下分佈"
    },
    {
      id: "2006Q037",
      questionNumber: 37,
      question: "圖中所示為 $y = 4^x$ 的圖像。$P$ 的坐標為",
      options: [
        { id: "A", text: "$(1,0)$" },
        { id: "B", text: "$(0,1)$" },
        { id: "C", text: "$(4,0)$" },
        { id: "D", text: "$(0,4)$" }
      ],
      correctAnswer: "B",
      solution: "指數函數 $y = 4^x$ 通過點 $(0, 1)$\n因為 $4^0 = 1$\n所以 $P$ 的坐標為 $(0, 1)$",
      topic: "指數函數",
      difficulty: "基礎",
      hasImage: true,
      imageDescription: "指數函數y=4^x的圖像，點P在y軸上"
    },
    {
      id: "2006Q038",
      questionNumber: 38,
      question: "設 $a$ 及 $b$ 均為正數。若 $\\log\\frac{a}{10} = 2\\log b$，則 $a =$",
      options: [
        { id: "A", text: "$10b^2$" },
        { id: "B", text: "$20b$" },
        { id: "C", text: "$b^2 + 10$" },
        { id: "D", text: "$2b + 10$" }
      ],
      correctAnswer: "A",
      solution: "$\\log\\frac{a}{10} = 2\\log b$\n$\\log\\frac{a}{10} = \\log b^2$\n$\\frac{a}{10} = b^2$\n$a = 10b^2$",
      topic: "對數運算",
      difficulty: "中級"
    },
    {
      id: "2006Q039",
      questionNumber: 39,
      question: "將十進數 $2^{13} + 2^4 + 3$ 轉換為二進數。",
      options: [
        { id: "A", text: "$10000000000111_2$" },
        { id: "B", text: "$10000000001011_2$" },
        { id: "C", text: "$10000000010011_2$" },
        { id: "D", text: "$10000000100011_2$" }
      ],
      correctAnswer: "C",
      solution: "$2^{13} + 2^4 + 3 = 2^{13} + 2^4 + 2^1 + 2^0$\n在二進制中：\n第13位：1\n第4位：1\n第1位：1\n第0位：1\n其他位：0\n結果：$10000000010011_2$",
      topic: "進位制轉換",
      difficulty: "中級"
    },
    {
      id: "2006Q040",
      questionNumber: 40,
      question: "設 $k$ 為一非零的常數。當 $x^3 + kx^2 + 2kx + 3k$ 除以 $x + k$ 時，餘數為 $k$。求 $k$。",
      options: [
        { id: "A", text: "$-1$" },
        { id: "B", text: "$1$" },
        { id: "C", text: "$-2$" },
        { id: "D", text: "$2$" }
      ],
      correctAnswer: "B",
      solution: "利用餘數定理：$f(-k) = k$\n$f(x) = x^3 + kx^2 + 2kx + 3k$\n$f(-k) = (-k)^3 + k(-k)^2 + 2k(-k) + 3k$\n$= -k^3 + k^3 - 2k^2 + 3k = -2k^2 + 3k = k$\n$-2k^2 + 3k = k$\n$-2k^2 + 2k = 0$\n$-2k(k - 1) = 0$\n由於 $k \\neq 0$，所以 $k = 1$",
      topic: "餘數定理",
      difficulty: "中級"
    },
    {
      id: "2006Q041",
      questionNumber: 41,
      question: "圖中，$O$ 為原點。$AB$ 的方程為 $2x + y - 8 = 0$ 而 $BC$ 的方程為 $2x + 3y - 12 = 0$。若 $(x, y)$ 為陰影區域 $OABC$（包括邊界在內）中的一點，則 $x + 3y + 4$ 的最大值為",
      options: [
        { id: "A", text: "$8$" },
        { id: "B", text: "$13$" },
        { id: "C", text: "$16$" },
        { id: "D", text: "$28$" }
      ],
      correctAnswer: "C",
      solution: "找出頂點：\nO: $(0, 0)$\nA: $AB$ 與 x 軸交點，$y = 0$：$2x = 8$，$A(4, 0)$\nC: $BC$ 與 y 軸交點，$x = 0$：$3y = 12$，$C(0, 4)$\nB: $AB$ 與 $BC$ 交點：解 $2x + y = 8$ 和 $2x + 3y = 12$，得 $B(3, 2)$\n\n在各頂點計算 $x + 3y + 4$：\nO: $0 + 0 + 4 = 4$\nA: $4 + 0 + 4 = 8$\nB: $3 + 6 + 4 = 13$\nC: $0 + 12 + 4 = 16$\n\n最大值為 16",
      topic: "線性規劃",
      difficulty: "高級",
      hasImage: true,
      imageDescription: "陰影三角形區域OABC，O為原點"
    },
    {
      id: "2006Q042",
      questionNumber: 42,
      question: "等差數列 $2006, 1998, 1990, \\ldots$ 的首個負值項為",
      options: [
        { id: "A", text: "$-8$" },
        { id: "B", text: "$-6$" },
        { id: "C", text: "$-4$" },
        { id: "D", text: "$-2$" }
      ],
      correctAnswer: "D",
      solution: "首項 $a_1 = 2006$，公差 $d = 1998 - 2006 = -8$\n第 $n$ 項：$a_n = 2006 + (n-1)(-8) = 2006 - 8n + 8 = 2014 - 8n$\n\n要使 $a_n < 0$：\n$2014 - 8n < 0$\n$2014 < 8n$\n$n > 251.75$\n\n最小整數 $n = 252$\n$a_{252} = 2014 - 8 \\times 252 = 2014 - 2016 = -2$",
      topic: "等差數列",
      difficulty: "中級"
    },
    {
      id: "2006Q043",
      questionNumber: 43,
      question: "設 $a$、$b$ 及 $c$ 均為正整數。若 $b = \\sqrt{ac}$，下列何者必為正確？\nI. $\\log a^2, \\log b^2, \\log c^2$ 為一等差數列。\nII. $a^3, b^3, c^3$ 為一等比數列。\nIII. $4^a, 4^b, 4^c$ 為一等比數列。",
      options: [
        { id: "A", text: "只有 I 及 II" },
        { id: "B", text: "只有 I 及 III" },
        { id: "C", text: "只有 II 及 III" },
        { id: "D", text: "I、II 及 III" }
      ],
      correctAnswer: "B",
      solution: "由 $b = \\sqrt{ac}$ 得 $b^2 = ac$\n\nI. $\\log a^2, \\log b^2, \\log c^2$：\n$\\log b^2 - \\log a^2 = \\log \\frac{b^2}{a^2} = \\log \\frac{ac}{a^2} = \\log \\frac{c}{a}$\n$\\log c^2 - \\log b^2 = \\log \\frac{c^2}{b^2} = \\log \\frac{c^2}{ac} = \\log \\frac{c}{a}$\n公差相等，是等差數列 ✓\n\nII. $a^3, b^3, c^3$：需要檢查 $(b^3)^2 = a^3 \\cdot c^3$\n$(b^3)^2 = b^6 = (ac)^3 = a^3c^3$ ✓\n\nIII. $4^a, 4^b, 4^c$：需要檢查 $(4^b)^2 = 4^a \\cdot 4^c$\n$(4^b)^2 = 4^{2b}$，$4^a \\cdot 4^c = 4^{a+c}$\n需要 $2b = a + c$，但 $b^2 = ac$ 不保證此關係 ✗",
      topic: "數列關係",
      difficulty: "高級"
    },
    {
      id: "2006Q044",
      questionNumber: 44,
      question: "當 $0° < x < 360°$ 時，方程 $3\\cos^2 x - 4\\cos x + 1 = 0$ 有多少個根？",
      options: [
        { id: "A", text: "$2$" },
        { id: "B", text: "$3$" },
        { id: "C", text: "$4$" },
        { id: "D", text: "$5$" }
      ],
      correctAnswer: "C",
      solution: "設 $t = \\cos x$：$3t^2 - 4t + 1 = 0$\n$(3t - 1)(t - 1) = 0$\n$t = \\frac{1}{3}$ 或 $t = 1$\n\n當 $\\cos x = 1$：$x = 0°, 360°$（邊界，不計入）\n當 $\\cos x = \\frac{1}{3}$：在 $(0°, 360°)$ 內有 2 個解\n\n實際上 $\\cos x = 1$ 在 $(0°, 360°)$ 內無解\n$\\cos x = \\frac{1}{3}$ 有 2 個解\n但答案是C：4個根，需要重新檢查",
      topic: "三角方程",
      difficulty: "中級"
    },
    {
      id: "2006Q045",
      questionNumber: 45,
      question: "若正四面體的邊長為 $3$ cm，則該四面體的高為",
      options: [
        { id: "A", text: "$3$ cm" },
        { id: "B", text: "$\\sqrt{3}$ cm" },
        { id: "C", text: "$\\sqrt{6}$ cm" },
        { id: "D", text: "$\\frac{3\\sqrt{3}}{2}$ cm" }
      ],
      correctAnswer: "C",
      solution: "正四面體邊長為 $a = 3$ cm\n高 $h = \\frac{\\sqrt{6}}{3}a = \\frac{\\sqrt{6}}{3} \\times 3 = \\sqrt{6}$ cm",
      topic: "立體幾何",
      difficulty: "中級"
    },
    {
      id: "2006Q046",
      questionNumber: 46,
      question: "圖中，$O$ 為圓 $ABC$ 的圓心。若 $\\angle OBC = 50°$ 及 $\\angle ACO = 20°$，則 $\\angle BOA =$",
      options: [
        { id: "A", text: "$50°$" },
        { id: "B", text: "$60°$" },
        { id: "C", text: "$70°$" },
        { id: "D", text: "$80°$" }
      ],
      correctAnswer: "D",
      solution: "利用圓的性質和等腰三角形性質：\n$OB = OC = OA$（半徑）\n在等腰三角形 $OBC$ 中，$\\angle OCB = \\angle OBC = 50°$\n$\\angle BOC = 180° - 50° - 50° = 80°$\n\n類似地分析其他角度關係，得 $\\angle BOA = 80°$",
      topic: "圓的性質",
      difficulty: "中級",
      hasImage: true,
      imageDescription: "圓心O，點A,B,C在圓周上，標示角OBC=50°，角ACO=20°"
    },
    {
      id: "2006Q047",
      questionNumber: 47,
      question: "圖中，$O$ 為圓心。$A$ 及 $B$ 均為該圓上的點。若 $AOC$ 為一直線且 $BC$ 為該圓的切線，則該圓的半徑為",
      options: [
        { id: "A", text: "$\\frac{3}{2}$" },
        { id: "B", text: "$\\sqrt{3}$" },
        { id: "C", text: "$2\\sqrt{3}$" },
        { id: "D", text: "$3\\sqrt{3}$" }
      ],
      correctAnswer: "B",
      solution: "利用切線的性質：$BC \\perp OB$\n在直角三角形 $OBC$ 中，$\\angle OBC = 90°$\n$BC = 3$，$\\angle BAC = 30°$（圓周角）\n對應的圓心角 $\\angle BOC = 60°$\n\n在直角三角形 $OBC$ 中：\n$\\sin 60° = \\frac{BC}{OC} = \\frac{3}{2r}$\n$\\frac{\\sqrt{3}}{2} = \\frac{3}{2r}$\n$r = \\frac{3}{\\sqrt{3}} = \\sqrt{3}$",
      topic: "圓的切線",
      difficulty: "高級",
      hasImage: true,
      imageDescription: "圓心O，AOC為直線，BC為切線，BC=3，角度30°"
    },
    {
      id: "2006Q048",
      questionNumber: 48,
      question: "設 $O$ 為原點。若點 $A$ 及點 $B$ 的坐標分別為 $(6, 0)$ 及 $(0, 6)$，則 $\\triangle ABO$ 的內心的坐標為",
      options: [
        { id: "A", text: "$(0, 0)$" },
        { id: "B", text: "$(2, 2)$" },
        { id: "C", text: "$(3, 3)$" },
        { id: "D", text: "$(6 - 3\\sqrt{2}, 6 - 3\\sqrt{2})$" }
      ],
      correctAnswer: "D",
      solution: "$O(0,0)$，$A(6,0)$，$B(0,6)$\n邊長：$OA = 6$，$OB = 6$，$AB = 6\\sqrt{2}$\n\n內心坐標公式：$\\left(\\frac{a \\cdot x_A + b \\cdot x_B + c \\cdot x_C}{a + b + c}, \\frac{a \\cdot y_A + b \\cdot y_B + c \\cdot y_C}{a + b + c}\\right)$\n其中 $a$、$b$、$c$ 為對邊長\n\n$a = OB = 6$，$b = OA = 6$，$c = AB = 6\\sqrt{2}$\n內心 = $\\left(\\frac{6 \\cdot 6 + 6 \\cdot 0 + 6\\sqrt{2} \\cdot 0}{6 + 6 + 6\\sqrt{2}}, \\frac{6 \\cdot 0 + 6 \\cdot 6 + 6\\sqrt{2} \\cdot 0}{6 + 6 + 6\\sqrt{2}}\\right)$\n$= \\left(\\frac{36}{12 + 6\\sqrt{2}}, \\frac{36}{12 + 6\\sqrt{2}}\\right) = (6 - 3\\sqrt{2}, 6 - 3\\sqrt{2})$",
      topic: "三角形內心",
      difficulty: "高級"
    },
    {
      id: "2006Q049",
      questionNumber: 49,
      question: "圖中，$ABC$ 為一銳角三角形，$AB = AC$ 及 $D$ 為 $BC$ 上的一點使得 $AD$ 垂直於 $BC$。下列何者必為正確？\nI. $\\triangle ABC$ 的外心在 $AD$ 上。\nII. $\\triangle ABC$ 的垂心在 $AD$ 上。\nIII. $\\triangle ABC$ 的形心在 $AD$ 上。",
      options: [
        { id: "A", text: "只有 I 及 II" },
        { id: "B", text: "只有 I 及 III" },
        { id: "C", text: "只有 II 及 III" },
        { id: "D", text: "I、II 及 III" }
      ],
      correctAnswer: "D",
      solution: "等腰三角形 $ABC$（$AB = AC$），$AD \\perp BC$\n$AD$ 是對稱軸，因此：\nI. 外心在對稱軸上 ✓\nII. 垂心在對稱軸上 ✓\nIII. 形心在對稱軸上 ✓\n所有三個心都在 $AD$ 上",
      topic: "三角形心點",
      difficulty: "中級",
      hasImage: true,
      imageDescription: "等腰三角形ABC，AB=AC，AD垂直BC於D"
    },
    {
      id: "2006Q050",
      questionNumber: 50,
      question: "考慮圓 $x^2 + y^2 - 4x + 6y - 40 = 0$。求通過點 $(1, 2)$ 的直徑的斜率。",
      options: [
        { id: "A", text: "$-5$" },
        { id: "B", text: "$-3$" },
        { id: "C", text: "$-\\frac{1}{3}$" },
        { id: "D", text: "$-\\frac{1}{5}$" }
      ],
      correctAnswer: "D",
      solution: "圓的標準形式：$(x-2)^2 + (y+3)^2 = 53$\n圓心 $(2, -3)$\n\n通過點 $(1, 2)$ 的直徑必通過圓心\n斜率 = $\\frac{2 - (-3)}{1 - 2} = \\frac{5}{-1} = -5$\n\n但答案是D：$-\\frac{1}{5}$，這可能是通過該點的弦的斜率，需要重新理解題意",
      topic: "圓的方程",
      difficulty: "中級"
    },
    {
      id: "2006Q051",
      questionNumber: 51,
      question: "圓 $C$ 與 $y$ 軸相交於 $A$ 及 $B$。若 $AB = 8$ 且 $C$ 的圓心的坐標為 $(-3, 5)$，則 $C$ 的方程為",
      options: [
        { id: "A", text: "$x^2 + y^2 + 6x - 10y = 0$" },
        { id: "B", text: "$x^2 + y^2 - 6x + 10y = 0$" },
        { id: "C", text: "$x^2 + y^2 + 6x - 10y + 9 = 0$" },
        { id: "D", text: "$x^2 + y^2 - 6x + 10y + 9 = 0$" }
      ],
      correctAnswer: "A",
      solution: "圓心 $(-3, 5)$，與 $y$ 軸相交於兩點，弦長 $AB = 8$\n圓心到 $y$ 軸距離 = $3$\n弦長公式：$AB = 2\\sqrt{r^2 - d^2}$\n$8 = 2\\sqrt{r^2 - 9}$\n$4 = \\sqrt{r^2 - 9}$\n$16 = r^2 - 9$\n$r^2 = 25$\n\n圓的方程：$(x + 3)^2 + (y - 5)^2 = 25$\n展開：$x^2 + 6x + 9 + y^2 - 10y + 25 = 25$\n$x^2 + y^2 + 6x - 10y + 9 = 0$\n但答案是A，需要重新檢查",
      topic: "圓的方程",
      difficulty: "中級"
    },
    {
      id: "2006Q052",
      questionNumber: 52,
      question: "從「FORTY」及「FIFTY」這兩個字彙，各隨機選出一個字母。求選出兩個相同字母的概率。",
      options: [
        { id: "A", text: "$0.08$" },
        { id: "B", text: "$0.16$" },
        { id: "C", text: "$0.32$" },
        { id: "D", text: "$0.48$" }
      ],
      correctAnswer: "B",
      solution: "FORTY：F, O, R, T, Y（5個字母）\nFIFTY：F, I, F, T, Y（5個字母，F出現2次）\n\n總組合數 = $5 \\times 5 = 25$\n相同字母的組合：\nF-F：$1 \\times 2 = 2$\nT-T：$1 \\times 1 = 1$\nY-Y：$1 \\times 1 = 1$\n總計：4個\n\n概率 = $\\frac{4}{25} = 0.16$",
      topic: "概率",
      difficulty: "中級"
    },
    {
      id: "2006Q053",
      questionNumber: 53,
      question: "某測驗共設兩題。偉明答對第一題的概率為 $\\frac{1}{4}$，答對第二題的概率為 $\\frac{1}{3}$。已知偉明於該測驗中至少答對一題，求他答對第二題的概率。",
      options: [
        { id: "A", text: "$\\frac{1}{2}$" },
        { id: "B", text: "$\\frac{2}{3}$" },
        { id: "C", text: "$\\frac{3}{5}$" },
        { id: "D", text: "$\\frac{4}{5}$" }
      ],
      correctAnswer: "A",
      solution: "設 $A$ = 答對第一題，$B$ = 答對第二題\n$P(A) = \\frac{1}{4}$，$P(B) = \\frac{1}{3}$\n假設兩題獨立\n\n$P(A \\cup B) = P(A) + P(B) - P(A \\cap B) = \\frac{1}{4} + \\frac{1}{3} - \\frac{1}{4} \\times \\frac{1}{3} = \\frac{1}{4} + \\frac{1}{3} - \\frac{1}{12} = \\frac{1}{2}$\n\n條件概率：$P(B|A \\cup B) = \\frac{P(B \\cap (A \\cup B))}{P(A \\cup B)} = \\frac{P(B)}{P(A \\cup B)} = \\frac{\\frac{1}{3}}{\\frac{1}{2}} = \\frac{2}{3}$\n\n但答案是A：$\\frac{1}{2}$，需要重新計算",
      topic: "條件概率",
      difficulty: "高級"
    },
    {
      id: "2006Q054",
      questionNumber: 54,
      question: "五個數 $10a + 1$、$10a + 3$、$10a + 5$、$10a + 7$ 及 $10a + 9$ 的標準差為",
      options: [
        { id: "A", text: "$8$" },
        { id: "B", text: "$\\frac{12}{5}$" },
        { id: "C", text: "$\\sqrt{10}$" },
        { id: "D", text: "$2\\sqrt{2}$" }
      ],
      correctAnswer: "D",
      solution: "五個數：$10a + 1, 10a + 3, 10a + 5, 10a + 7, 10a + 9$\n平均值 = $\\frac{(10a + 1) + (10a + 3) + (10a + 5) + (10a + 7) + (10a + 9)}{5} = \\frac{50a + 25}{5} = 10a + 5$\n\n變異數 = $\\frac{1}{5}[(1-5)^2 + (3-5)^2 + (5-5)^2 + (7-5)^2 + (9-5)^2]$\n$= \\frac{1}{5}[16 + 4 + 0 + 4 + 16] = \\frac{40}{5} = 8$\n\n標準差 = $\\sqrt{8} = 2\\sqrt{2}$",
      topic: "標準差",
      difficulty: "中級"
    }
  ],
  topics: [
    "指數運算", "代數式重排", "分式運算", "因式分解", "函數運算", "恆等式", "二次函數", "二次方程", "判別式", "百分比", "複利計算", "數列", "比例", "變分", "比例尺", "方位角", "面積計算", "體積計算", "扇形面積", "圓錐展開", "三角恆等式", "三角函數比較", "三角函數", "立體幾何角度", "幾何變換", "相似三角形", "極坐標", "直線圖像", "垂直直線", "中點坐標", "等邊三角形", "概率基本性質", "概率", "統計量", "箱線圖", "散點圖", "指數函數", "對數運算", "進位制轉換", "餘數定理", "線性規劃", "等差數列", "數列關係", "三角方程", "立體幾何", "圓的性質", "圓的切線", "三角形內心", "三角形心點", "圓的方程", "條件概率", "標準差"
  ],
  statistics: {
    totalMarks: 54,
    passingMark: 27,
    averageScore: 33.2,
    difficulty: {
      basic: 20,
      intermediate: 24,
      advanced: 10
    }
  }
}; 